class ProductServicesDetailsDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    // 使用事件委托处理遮罩层点击
    this.addEventListener('click', (evt) => {
      if (evt.target.id === 'ProductServicesDetailsDrawer-Overlay' || 
          evt.target.classList.contains('product-services-details-drawer__overlay')) {
        this.close();
      }
    });
  }

  open() {
    // 防止页面抖动：计算滚动条宽度并设置padding补偿
    this.preventLayoutShift();

    // 聚焦到 drawer
    const inner = this.querySelector('.product-services-details-drawer__inner');
    if (inner) {
      inner.focus();
    }

    // 添加 active 类来显示 drawer
    setTimeout(() => {
      this.classList.add('active');
    });
  }

  close(focusToggle = true) {
    this.classList.remove('active');

    // 恢复页面滚动
    document.body.classList.remove('overflow-hidden');
    const scrollbarWidth = document.documentElement.style.getPropertyValue('--scrollbar-width');
    if (scrollbarWidth) {
      document.body.style.paddingRight = '';
      document.documentElement.style.removeProperty('--scrollbar-width');
    }

    // 恢复焦点
    if (focusToggle && this.activeElement) {
      this.activeElement.focus();
    }
  }

  preventLayoutShift() {
    // 计算滚动条宽度
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    // 防止页面滚动
    document.body.classList.add('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('product-services-details-drawer', ProductServicesDetailsDrawer);
